import header from "./badezimmer-1.webp";
import section1 from "./bathroom-with-shower-toilet.jpg";
import section2 from "./badezimmer-2.webp";
import section3 from "./grundriss-badezimmer-de.jpg";
import section4 from "./bathroom-with-black-tile-interior.jpg";
import section5 from "./Grundriss-Badezimmer-02.jpg";
import section6 from "./modern-bathroom-with-shower.jpg";

export { header, section1, section2, section3, section4, section5, section6 };
